<template>
  <div>
    <h2>余额查询</h2>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Table :max-height="height" ref="selection" :data="dataList" :columns="columns" stripe border></Table>
    <div style="padding: 10px 0px 0px 0px">
      <Page
        :current="pageNo"
        :total="total"
        :page-size="pageSize"
        show-sizer
        show-total
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      ></Page>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    meterId: ""
  },
  mounted() {
    this.getMeasurementRecord(this.meterId);
  },
  data() {
    return {
      isSpinShow: false,
      height: document.body.clientHeight * 0.8,
      width: document.body.clientWidth,
      columns: [],
      dataList: [],
      total: 0,
      pageSize: 10,
      pageNo: 1,
      meterId: ""
    };
  },
  methods: {
    changePage(page) {
      this.pageNo = page;
      this.getMeasurementRecord(this.meterId);
    },
    changePageSize(size) {
      this.pageSize = size;
      this.getMeasurementRecord(this.meterId);
    },
    getMeasurementRecord(param) {
      this.meterId = param;
      var that = this;
      this.isSpinShow = true;
      $.ajax({
        url:
          "/api/instructions/searchUpInstructions?page=" +
          that.pageNo +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          commandDeviceId: that.meterId,
          commandType: "0x85",
          page: that.pageNo,
          pageAmount: that.pageSize
        }),
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.body == null) {
            return;
          }
          that.columns = receiveData.body.columns;
          that.dataList = receiveData.body.resultList;
          that.total = receiveData.body.amount;

          that.columns.map((item, index) => {
            if (item.key == "commandTimestamp") {
              item["fixed"] = "left";
              item["width"] = that.width * 0.35;
            } else {
              item["width"] = that.width * 0.2;
            }
            console.log(item);
            return item;
          });
          console.log(that.columns);
          that.isSpinShow = false;
        },
        error: function(textStatus) {
          that.isSpinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    }
  }
};
</script>

<style>
.ivu-table td,
.ivu-table th {
  min-width: 0;
  height: 40px;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  border-bottom: 1px solid #e8eaec;
}
</style>
